export default {
	/**
	 * 登录相关
	 */
	CURRENT_USER: '/user', // 获取当前登录用户信息
	USER_LOGIN: '/user/login', // 登录
	USER_LOGOUT: '/user/logout', // 登出
	USER_REGISTER: '/user/register', // 注册
	USER_RESET_MAIL: '/user/reset/mail', // 发送密码重置邮件
	USER_RESET_PWD: '/user/reset/password', // 发送密码重置邮件
	REG_SUCCESS: '/reg/success', // 发送注册成功邮件
	/**
	 * 基本信息
	 */
	USER_BASIC: '/user/basic', // 新增或更新用户基本信息
	USER_BASIC_VIEWED_SUCCESS_PAGE: '/user/basic/update_viewedSuccessPage', // 注册成功页面状态的修改接口
	USER_BASIC_VIEWED_DOC_DIALOG: '/user/basic/update_viewedDocumentDialog', // 与会文件弹窗状态的修改接口
	/**
	 * 协议
	 */
	PROTOCOL_INFO: '/protocol', // 获取协议
	VISA_INVITATION: '/visa/get',
	/**
	 * 文案管理相关
	 */
	GET_CONTENT: '/content/get', // 获取文案信息
	/**
	 * 活动
	 */
	ACTIVITY_ALL: '/activity/all', // 获取活动列表信息
	ACTIVITY_USER_RELATE: '/activity/addUserActivity', // 添加用户活动关系
	/**
	 * 机票
	 */
	FLIGHT_INFO: '/flight/front/info', // 获取机票信息
	FLIGHT_UPDATE: '/flight/front/update', // 更新机票信息
	FLIGHT_IS_FINISH: '/flight/front/query_is_finish', // 查询机票信息是否完善
	FLIGHT_CITY: '/city', // 搜索城市列表
	/**
	 * 酒店
	 */
	HOTEL_INFO: '/hotel/front/info', // 获取酒店信息
	HOTEL_UPDATE: '/hotel/front/update', // 添加或修改嘉宾酒店信息
	/**
	 * 文档
	 */
	DOCUMENT_INFO: '/documentManage/get', // 获取文档详情
	DOCUMENT_LECTURE_ADD: '/lecture/add', // 添加用户演讲题目
	DOCUMENT_LECTURE_UPDATE: '/lecture/update', // 更新用户演讲题目
	DOCUMENT_UPLOAD: '/document' // 上传文档
}
